<div class="dln-dt-calendar-control">
    <div class="dln-dt-calendar-control-content">
        <span class="month">{{periodButtonText}} - </span>
        <span class="today" (click)="selectToday($event)">{{today.format('ll')}}</span>
    </div>

    <button class="dln-dt-control-button dln-dt-control-arrow-button dln-dt-control-arrow-button-left"
            type="button" tabindex="0"
            [style.visibility]="showControlArrows? 'visible': 'hidden'"
            [disabled]="!prevButtonEnabled()"
            [attr.aria-label]="prevButtonLabel"
            (click)="previousClicked()">
          <span class="dln-dt-control-button-content" tabindex="-1">
              <i class="icon-chevron-left"></i>
          </span>
    </button>

    <button class="dln-dt-control-button dln-dt-control-arrow-button"
            type="button" tabindex="0"
            [style.visibility]="showControlArrows? 'visible': 'hidden'"
            [disabled]="!nextButtonEnabled()"
            [attr.aria-label]="nextButtonLabel"
            (click)="nextClicked()">
        <span class="dln-dt-control-button-content" tabindex="-1">
            <i class="icon-chevron-right"></i>
        </span>
    </button>
</div>
<div class="dln-dt-calendar-main" cdkMonitorSubtreeFocus [ngSwitch]="currentView">
    {{minDate}} {{maxDate}}
    <dln-date-time-month-view
        *ngSwitchCase="'month'"
        [pickerMoment]="pickerMoment"
        [firstDayOfWeek]="firstDayOfWeek"
        [selected]="selected"
        [selecteds]="selecteds"
        [selectMode]="selectMode"
        [minDate]="minDate"
        [maxDate]="maxDate"
        [dateFilter]="dateFilter"
        (pickerMomentChange)="handlePickerMomentChange($event)"
        (selectedChange)="dateSelected($event)"
        [eventMode]="eventMode" [events]="events"
        (userSelection)="userSelected()"></dln-date-time-month-view>
</div>
